import React from 'react'
import ReactDOM from 'react-dom'
import propTypes from 'prop-types'

import Head from './Head'
import Location from './Location'
import SearchHistory from './SearchHistory'
import Style from './index.less'

import { QueryAllGroupFlightCityList } from '@src/api'
import { UtilPhone } from '../../../utils'
import { UtilDevice } from '@iskytrip/sdk'
import BaseComponent from '../../../base/BaseComponent'

import BACK_PNG from '@assets/components/back.png'
import CHOOSE_PNG from '@assets/components/choose.png'
import SEARCH_PNG from '@assets/components/search.png'
import ClOSED_PNG from '@assets/components/closed.png'

/*
 组件传入参数
    isLocation: true
    isAirportCar: true/false 是否是接送机使用 默认false
    isCitySelect: true/false (展示/隐藏)
    isFullScreen: 是否全屏显示
    赋值方法 getTimeValue props
    例子 ： <CitySelect getCityValue={(val)=>this.getCityValue(val)}/>
}*/
class CitySelect extends BaseComponent {
	static propTypes = {
		isHot: propTypes.bool,
		isHistory: propTypes.bool,
		isLocation: propTypes.bool,
		isFullScreen: propTypes.bool,
		isPage: propTypes.bool,
		isAllCity: propTypes.bool,
	}

	static defaultProps = {
		isHot: true,
		isHistory: true,
		isLocation: true,
		isFullScreen: true,
		isPage: false,
		isAllCity: false,
	}

	constructor(props) {
		super(props)
		const { isAirportCar } = this.props
		this.state = {
			HistoryList: {
				initial: '历史搜索',
				cityList: [],
			},
			tabIndex: 0,
			result: {
				cityGroupList: [],
				extCityGroupList: [],
				hotCityList: {
					initial: '热门城市',
					cityList: [],
				},
			},
			isShowHistory: false,
			isShowCitySelect: false,
			paddingtop: 20,
			isAirportCar: isAirportCar || false,
		}
		this.historylist = []
		this.source = this.props.source
		this.pageHeight = 0
	}

	componentDidUpdate() {
		const data = null //DomUtil.getLocalStorage('search_History'); qj
		if (data) {
			if (JSON.parse(data).length !== this.historylist.length) {
				let historyList = this.state.HistoryList
				historyList.cityList = JSON.parse(data)
				this.historylist = JSON.parse(data)

				this.setState({
					HistoryList: historyList,
				})
			} else {
				this.historylist.forEach((v, k) => {
					if (+v.cityId !== +JSON.parse(data)[k].cityId) {
						let historyList = this.state.HistoryList
						historyList.cityList = JSON.parse(data)
						this.historylist = JSON.parse(data)

						this.setState({
							HistoryList: historyList,
						})
					}
				})
			}
		}
	}

	componentDidMount() {
		let that = this
		this.pageHeight = document.body.offsetHeight

		// if (UtilDevice.isApp()) {
		//     appGetSignalBarHeight((height) => {
		//         that.setState({
		//             paddingtop: /* UtilDevice.isIpX() ? 44 : UtilDevice.isIOS() ? 20 :  */height
		//         })
		//     })
		// }

		const data = null //DomUtil.getLocalStorage('search_History'); qj
		// alert(data);
		if (data) {
			let historyList = that.state.HistoryList
			historyList.cityList = JSON.parse(data)
			that.historylist = JSON.parse(data)

			that.setState({
				HistoryList: historyList,
			})
		}

		let params = {}
		if (this.props.isQuery === false) {
			params.isQuery = this.props.isQuery
		}
		const queryAllGroupFlightCityListModel = new QueryAllGroupFlightCityList(params)
		queryAllGroupFlightCityListModel.execute().then(({ internal, external }) => {
			that.setState({
				result: {
					cityGroupList: internal,
					extCityGroupList: external,
					hotCityList: this.state.result.hotCityList,
				},
			})
		})
		const self = this
		;(function() {
			let ul = document.querySelector('.quickly-select-contain')
			let header = document.querySelector('.city-select-index')

			const { isFullScreen } = self.props

			ul.addEventListener(
				'touchmove',
				(event) => {
					event.preventDefault()
					event.stopPropagation()
					var coordinateX = parseInt(event.changedTouches[0].clientX)
					var coordinateY = parseInt(event.changedTouches[0].clientY)
					if (coordinateY < 0) return //滑动到页面外 结束流程
					var realTarget = document.elementFromPoint(coordinateX, coordinateY)
					let id = null
					if (!!realTarget && !!realTarget.innerHTML)
						realTarget.innerHTML.trim() === '热门'
							? (id = 'hotCity')
							: (id = realTarget.innerHTML.trim())
					let offH = header.clientHeight
					if (!isFullScreen) {
						offH = 100 + header.clientHeight + self.state.paddingtop
					}
					//!!document.getElementById(`${id}`) && document.getElementById(`${id}`).scrollIntoView();
					// eslint-disable-next-line no-extra-boolean-cast
					if (!!document.getElementById(`${id}`)) {
						// eslint-disable-next-line no-extra-boolean-cast
						if (!!document.getElementsByClassName('city-select-scroll')[0].scrollTo) {
							document
								.getElementsByClassName('city-select-scroll')[0]
								.scrollTo(0, document.getElementById(`${id}`).offsetTop - offH)
						} else {
							document.getElementsByClassName('city-select-scroll')[0].scrollTop =
								document.getElementById(`${id}`).offsetTop - offH
						}
					}
				},
				{
					passive: false, //禁止passive 效果
				},
			)
			// 阻止点击穿透 优化侧边栏字母touchMove事件
			// document.addEventListener("click",function(ev){ ev.preventDefault();})
			document.addEventListener('touchmove', optimizingTouchMoveHandle)
		})()

		function optimizingTouchMoveHandle(e) {
			if (
				UtilPhone.iosPenetrate() ||
				(e.target && !e.target.closest('.city-select-scroll'))
			) {
				e.preventDefault()
			}
		}

		return function cleanDocumentEvent() {
			document.removeEventListener('touchmove', optimizingTouchMoveHandle)
		}
	}

	getSignalBarHeight(height) {
		this.setState({
			paddingtop: height,
		})
	}

	hotHistoryList() {
		const { HistoryList } = this.state

		let historyCount = HistoryList.cityList.length
		if (historyCount === 0) {
			return
		}

		let hotHistoryList = HistoryList.cityList.map((itemEle, idx) => {
			if (
				!!this.props.currentCity &&
				!!this.props.currentCity.cityId &&
				+this.props.currentCity.cityId === +itemEle.cityId
			) {
				return (
					<div
						key={`${idx}`}
						data-id={itemEle.cityId}
						data-name={itemEle.name}
						className='hot-ele hot-ele-current'
						onClick={() => this._selectCity(itemEle)}
					>
						{itemEle.name}
					</div>
				)
			} else
				return (
					<div
						key={`${idx}`}
						data-id={itemEle.cityId}
						data-name={itemEle.name}
						className='hot-ele'
						onClick={() => this._selectCity(itemEle)}
					>
						{itemEle.name}
					</div>
				)
		})

		return (
			<div className='hotHistory_box'>
				<div>
					<div className='hot-title'>{HistoryList.initial}</div>
					<div className='hot-content'>
						{hotHistoryList}
						{Math.floor(historyCount % 3) === 2 && <div className='hot-none'></div>}
					</div>
				</div>
			</div>
		)
	}

	hotCityList() {
		const { result } = this.state

		let hotcityCount = result.hotCityList.cityList.length

		if (hotcityCount === 0) {
			return
		}

		let hotCityList = result.hotCityList.cityList.map((itemEle, idx) => {
			if (
				!!this.props.currentCity &&
				!!this.props.currentCity.cityId &&
				+this.props.currentCity.cityId === +itemEle.cityId
			) {
				return (
					<div
						key={`${idx}`}
						data-id={itemEle.cityId}
						data-name={itemEle.name}
						className='hot-ele hot-ele-current'
						onClick={() => this._selectCity(itemEle)}
					>
						{itemEle.name}
					</div>
				)
			} else
				return (
					<div
						key={`${idx}`}
						data-id={itemEle.cityId}
						data-name={itemEle.name}
						className='hot-ele'
						onClick={() => this._selectCity(itemEle)}
					>
						{itemEle.name}
					</div>
				)
		})

		return (
			<div className='hotHistory_box'>
				<div id='hotCity'>
					<div className='hot-title'>{result.hotCityList.initial}</div>
					<div className='hot-content'>
						{hotCityList}
						{Math.floor(hotcityCount % 3) === 2 && <div className='hot-none'></div>}
					</div>
				</div>
			</div>
		)
	}

	leftList() {
		const { tabIndex, result, currentCity } = this.state

		const leftList = result[!tabIndex ? 'cityGroupList' : 'extCityGroupList'].map(
			(item, index) => (
				<div key={index} id={item.initial}>
					<div className='city-title'>{item.initial}</div>
					<div className='city-contain'>
						{item.cityList.map((itemEle, idx) => {
							if (
								!!currentCity &&
								!!currentCity.cityId &&
								+currentCity.cityId === +itemEle.cityId
							) {
								return (
									<div
										key={`${index}_${idx}`}
										data-id={itemEle.cityId}
										data-name={itemEle.name}
										className='city-content city-content-current'
										onClick={() => this._selectCity(itemEle)}
									>
										<span>{itemEle.name}</span>
										<img
											alt='choose'
											className='city-select-status'
											src={CHOOSE_PNG}
										/>
									</div>
								)
							} else
								return (
									<div
										key={`${index}_${idx}`}
										data-id={itemEle.cityId}
										data-name={itemEle.name}
										className='city-content'
										onClick={() => this._selectCity(itemEle)}
									>
										{itemEle.name}
									</div>
								)
						})}
					</div>
				</div>
			),
		)

		return <div className='left_box'>{leftList}</div>
	}

	rightList() {
		const { isHot, isFullScreen } = this.props
		const { tabIndex, result } = this.state

		let hotcityCount = result.hotCityList.cityList.length

		let rightList = result[!tabIndex ? 'cityGroupList' : 'extCityGroupList'].map(
			(item, index) => (
				<li
					key={index + 1}
					className='quickly-select-content'
					onClick={() => this._cityLocation(item)}
				>
					{item.initial}
				</li>
			),
		)

		return (
			<ul
				className='quickly-select-contain'
				style={{
					top: isFullScreen ? '28%' : '38%',
				}}
			>
				{hotcityCount > 0 && isHot && (
					<li
						key={0}
						className='quickly-select-content'
						onClick={() => this._cityLocation(result.hotCityList)}
					>
						{'热门'}
					</li>
				)}
				{rightList}
			</ul>
		)
	}

	_cityLocation(item) {
		const { isFullScreen } = this.props

		let initial = item.initial
		let id = initial

		if (initial === '热门城市') {
			id = 'hotCity'
		}
		let offH = 84 + this.state.paddingtop
		if (!isFullScreen) {
			offH = 194 + this.state.paddingtop
		}
		// eslint-disable-next-line no-extra-boolean-cast
		if (!!document.getElementById(`${id}`)) {
			// eslint-disable-next-line no-extra-boolean-cast
			if (!!document.getElementsByClassName('city-select-scroll')[0].scrollTo) {
				document
					.getElementsByClassName('city-select-scroll')[0]
					.scrollTo(0, document.getElementById(`${id}`).offsetTop - offH)
			} else {
				document.getElementsByClassName('city-select-scroll')[0].scrollTop =
					document.getElementById(`${id}`).offsetTop - offH
			}
		}
	}

	_searchClick() {
		this.setState({
			isShowHistory: !this.state.isShowHistory,
		})
	}

	_showOrhide() {
		this.setState({
			isShowCitySelect: !this.state.isShowCitySelect,
		})
	}

	getCityValue(list) {
		try {
			this.props.getCityValue(list)
		} catch (e) {
			console.log('暂无回调方法')
		}
	}

	_selectCity(item) {
		const { cityId, name, ...res } = item
		let that = this
		let flag = 1
		let historyList = that.state.HistoryList
		let value = { cityId, name, addressCode: 0, address: '', ...res }
		const { isAirportCar } = this.state
		if (isAirportCar) {
			value.adCode = item.adCode
			value.shortSpelling = item.shortSpelling
			value.spelling = item.spelling
		}

		if (this.historylist.length > 0) {
			this.historylist.forEach((v, index) => {
				if (+v.cityId === +cityId) {
					this.historylist.splice(index, 1)
					flag = 0
				}
			})

			if (+flag === 0) {
				this.historylist.unshift(value)
			} else {
				if (this.historylist.length >= 4) {
					this.historylist.splice(3, 1)
					this.historylist.unshift(value)
				} else {
					this.historylist.unshift(value)
				}
			}
		} else {
			this.historylist.unshift(value)
		}
		historyList.cityList = JSON.parse(JSON.stringify(this.historylist))
		that.setState(
			{
				HistoryList: historyList,
				currentCity: value,
			},
			() => {
				that.getCityValue(value)
				that._showOrhide()
			},
		)
	}

	getHistory(list) {
		this.historylist = list
		let historyList = this.state.HistoryList
		historyList.cityList = list
		this.setState({
			HistoryList: historyList,
		})
	}

	render() {
		const { isHot, isHistory, isLocation, isFullScreen, isPage, isAllCity } = this.props
		const { isShowHistory, isShowCitySelect, paddingtop, isAirportCar } = this.state
		const isMiniApp = UtilDevice.isWxMini() || UtilDevice.isAlipayClient()

		if (isShowCitySelect && [...document.body.classList].indexOf('over-hide') === -1) {
			document.body.classList.add('over-hide')
		} else if (!isShowCitySelect) {
			document.body.classList.remove('over-hide')
		}

		return ReactDOM.createPortal(
			<>
				<style dangerouslySetInnerHTML={{ __html: Style }} />
				<div
					className='component_city-select'
					style={{
						display: isShowCitySelect ? 'block' : 'none',
						backgroundColor: isFullScreen ? 'white' : 'transparent',
					}}
				>
					{!isFullScreen ? (
						<div
							className='modal_bg'
							style={{ paddingTop: paddingtop }}
							onClick={this._showOrhide.bind(this)}
						></div>
					) : null}
					<div
						className='component_city-select-contain'
						style={{ display: isShowHistory ? 'none' : 'block' }}
					>
						<div
							className='city-select-index'
							style={{ paddingTop: isFullScreen ? paddingtop : 10 }}
						>
							<div className='city-select-search'>
								{!isMiniApp && (
									<img
										alt='back'
										src={isFullScreen ? BACK_PNG : ClOSED_PNG}
										className={
											isFullScreen
												? 'city-select-search-back'
												: 'city-select-search-closed'
										}
										onClick={() => {
											if (isFullScreen && isPage) {
												if (UtilDevice.isApp()) {
													this.back()
												} else {
													uni.navigateBack()
												}
											}
											this._showOrhide()
										}}
									/>
								)}

								<div
									style={{ marginLeft: '12px' }}
									className='city-select-search-input-con'
									onClick={() => this._searchClick()}
								>
									<div
										disabled
										style={{ opacity: 1 }}
										className='city-select-search-input'
										placeholder=''
									></div>
									<img
										alt='search'
										src={SEARCH_PNG}
										className='city-select-search-input-search-logo'
									/>
									<div className='city-select-search-input-placehoder'>
										搜索城市，如北京/beijing
									</div>
								</div>
							</div>
							<Head
								changeTab={(tab) => {
									console.log(tab)
									this.setState({ tabIndex: tab })
								}}
							/>
							{/* <div className="city-select-gradient"></div> */}
						</div>
						<div
							className='city-select-scroll'
							style={{
								height: isFullScreen
									? this.pageHeight - 84 - paddingtop
									: this.pageHeight - 184 - paddingtop,
							}}
						>
							{isShowCitySelect && isLocation && (
								<Location
									_showOrhide={() => this._showOrhide()}
									getCityValue={(val) => this.props.getCityValue(val)}
								></Location>
							)}
							{isHistory && this.hotHistoryList()}
							{isHot && this.hotCityList()}
							{this.leftList()}
							{this.rightList()}
						</div>
					</div>
					{isShowHistory && (
						<SearchHistory
							isFullScreen={isFullScreen}
							isAllCity={isAllCity}
							isAirportCar={isAirportCar}
							getHistory={(val) => this.getHistory(val)}
							searchClick={() => this._searchClick()}
							_showOrhide={() => this._showOrhide()}
							getCityValue={(val) => this.props.getCityValue(val)}
						></SearchHistory>
					)}
				</div>
			</>,
			document.getElementById('app'),
		)
	}
}

export default CitySelect
